import Sidebar from "./components/sideBar/Sidebar";
import Topbar from "./components/topBar/Topbar";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./components/dashboard/Dashboard";
import Maps from "./components/maps/Maps";
import Reports from "./components/reports/Reports";
import Actions from "./components/actions/Actions";
import Zones from "./components/zones/Zones";
import RemoteAccess from "./components/remoteAccess/RemoteAccess";
import Login from "./components/login/Login";
import Calendar from "./components/calendar/Calendar";
import Support from "./components/support/Support";
import { useAuth } from "./components/auth/AuthContext";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const { isAuthenticated, loading } = useAuth();
  const showAppShell = !isLoginPage && isAuthenticated;

  return (
    <div className="App">
      {showAppShell && <Topbar />}
      {showAppShell && <Sidebar />}

      <Routes>
        <Route
          path="/login"
          element={loading ? null : (isAuthenticated ? <Navigate to="/" replace /> : <Login />)}
        />

        {/* Protected Routes */}
        <Route index element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="maps" element={<PrivateRoute><Maps /></PrivateRoute>} />
        <Route path="actions" element={<PrivateRoute><Actions /></PrivateRoute>} />
        <Route path="calendar" element={<PrivateRoute><Calendar /></PrivateRoute>} />
        <Route path="reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="zones" element={<PrivateRoute><Zones /></PrivateRoute>} />
        <Route path="remote-access" element={<PrivateRoute><RemoteAccess /></PrivateRoute>} />
        <Route path="user" element={<PrivateRoute><Support /></PrivateRoute>} />
        <Route path="support" element={<Navigate to="/user" replace />} />
      </Routes>
    </div>
  );
}

export default App;
